import { spacer16, spacer48 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { cssColorValue } from "../../styles";
export var IconContainer = styled.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-8qkwwp-0"
})(["align-items:center;border-radius:50%;display:flex;block-size:", ";justify-content:center;margin-block-start:0;margin-block-end:", ";margin-inline-start:auto;margin-inline-end:auto;inline-size:", ";background-color:", ";"], spacer48, spacer16, spacer48, cssColorValue('backgroundBase'));